import * as yup from 'yup';
import { MSJ_YUP, REGEX_YUP } from '../validation/mensajesGenericos';

const kilometraje = yup.number()
    .typeError(MSJ_YUP.NUMERO)
    .required(MSJ_YUP.REQUERIDO)
    .min(1, MSJ_YUP.MAYOR_CERO)
    .max(999999, 'No puede superar 999999');

export const mantencionSchema = yup.object().shape({
  empresa: yup.string()
    .required("Debes seleccionar una empresa"),
  servicio: yup.array()
    .of(yup.string())
    .min(1, "Debes seleccionar al menos un servicio")
    .required("Debes seleccionar al menos un servicio"),
  cliente: yup.string()
    .matches(REGEX_YUP.LETRAS, MSJ_YUP.LETRAS)
    .required(MSJ_YUP.REQUERIDO),
  rut: yup.string()
    .matches(REGEX_YUP.RUT, MSJ_YUP.RUT)
    .required(MSJ_YUP.REQUERIDO),
  celular: yup.string()
    .matches(REGEX_YUP.CELULAR, MSJ_YUP.CELULAR)
    .required(MSJ_YUP.REQUERIDO),
  correo: yup.string().notRequired()
    .email(MSJ_YUP.CORREO).nullable(),
  patente: yup.string()
    .matches(REGEX_YUP.PATENTE_ALFANUM, MSJ_YUP.PATENTE)
    .required(MSJ_YUP.REQUERIDO),
  marca: yup.string().required(MSJ_YUP.REQUERIDO),
  modelo: yup.string().required(MSJ_YUP.REQUERIDO),
  anio: yup.number()
    .typeError(MSJ_YUP.NUMERO)
    .required(MSJ_YUP.REQUERIDO)
    .min(1900, 'Año debe ser mayor a 1900')
    .max(new Date().getFullYear() + 1, 'Año invalido'),
  nserie: yup.string().notRequired()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .matches(REGEX_YUP.ALFANUM, MSJ_YUP.ALFANUM).nullable(),
  nmotor: yup.string().notRequired()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .matches(REGEX_YUP.ALFANUM, MSJ_YUP.ALFANUM).nullable(),
  kilometrajeAct: kilometraje,
  kilometrajeProx: kilometraje,
  observaciones: yup.string().notRequired(),
  diagnostico: yup.string().notRequired(),
  ultimaReparacion: yup.string().notRequired(),
  recomendacion: yup.string().notRequired(),
  obsmecanico: yup.string().notRequired(),
  fechaIngreso: yup.date()
    .typeError(MSJ_YUP.FECHA)
    .required(MSJ_YUP.REQUERIDO),
  fechaSalida: yup.date()
    .typeError(MSJ_YUP.FECHA)
    .required(MSJ_YUP.REQUERIDO),
});